// Table cell text and the name a record goes by (DataTable). getVal used to cut any text with a "T" in it ("Thruster Seal
// Kit" -> "", "E2E-OFF Test Pump" -> "E2E-OFF "): only an ISO date-time (2026-10-19T23:24:50...) is cut to its date now.
export const ISO_DATETIME = /^\d{4}-\d{2}-\d{2}T/
export function getVal(v) {
  if (!v) return '-'
  if (typeof v === 'boolean') return v ? 'Yes' : 'No'
  if (typeof v === 'object' && !Array.isArray(v)) return v.value || v.name || v.label || '-'
  if (Array.isArray(v) && v.length > 0) return v[0].value || v[0].name || String(v[0]) || '-'
  if (Array.isArray(v) && v.length === 0) return '-'
  const s = String(v)
  return ISO_DATETIME.test(s) ? s.slice(0, 10) : s
}

// the record's own title / name column (in this order) - never created_at, an id, a date or a number
export const TITLE_KEYS = ['Name', 'Task Name', 'Task', 'Part Name', 'Title', 'Crew Member', 'Crew Name', 'Log Entry', 'Charter Ref', 'Port Call', 'Port', 'Lead Guest', 'Description', 'Subject', 'title', 'name']
const NOT_A_NAME = /^(id|uuid|created_at|updated_at|client_id|vessel_id|.*_id|.*\bID|.*UID|.*Date|.*date|Status|Quantity|Cost|Hours.*|.*Hours|File URL|Photo URL)$/
const looksLikeId = s => ISO_DATETIME.test(s) || /^\d{4}-\d{2}-\d{2}$/.test(s) || /^[0-9a-f]{8}-[0-9a-f]{4}-/i.test(s) || /^[\d.,\s:+-]+$/.test(s)
const text = v => { const s = getVal(v); return s === '-' ? '' : String(s).trim() }
export function recordName(row) {
  if (!row) return 'this record'
  for (const k of TITLE_KEYS) { const s = text(row[k]); if (s && !looksLikeId(s)) return s }
  for (const k of Object.keys(row)) {
    if (NOT_A_NAME.test(k)) continue
    const s = text(row[k]); if (s && !looksLikeId(s) && s.length <= 120) return s
  }
  return 'this record'
}
